import { type ICompanySupportChatQuery } from 'application/querySchemas/ICompanySupportChatQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type ICompanySupportChatMessagesClient,
    IGetResponse,
} from 'interfaceAdapter/gatewaySchemas/ICompanySupportChatMessagesClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanySupportChatQuery implements ICompanySupportChatQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanySupportChatMessagesClient')
        public readonly companySupportChatMessagesClient: ICompanySupportChatMessagesClient,
    ) {}

    public async fetchMessages(): Promise<IGetResponse['data']> {
        const { data, message } = await this.companySupportChatMessagesClient.get({
            token: this.companyUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data;
    }
}

